import { render, staticRenderFns } from "./DirectoryDetails.vue?vue&type=template&id=0f1773c4"
import script from "./DirectoryDetails.vue?vue&type=script&lang=js"
export * from "./DirectoryDetails.vue?vue&type=script&lang=js"
import style0 from "./DirectoryDetails.vue?vue&type=style&index=0&id=0f1773c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports